.top {
  padding: 84px 0;
}

/* Cream band, closed top and bottom, so the two boards read as distinct. */
.popular {
  padding: 84px 0;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-bottom: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

/* Heading and category filter share a row, bottom-aligned; the filter drops under the heading
   when the two no longer fit side by side. */
.top__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px 40px;
  flex-wrap: wrap;
  margin-bottom: 48px;
}

/* The wide head carries that 48px itself elsewhere; here the row above owns it.
   Class doubled to outrank `SectionHead`'s own `.head`/`.headWide`, which sit at the same
   specificity in another module — same reason as `.money__head.money__head`. */
.top__headText.top__headText {
  /* HACK: basis picked so the heading and the 304px filter wrap together, not one word at a time. */
  flex: 1 1 420px;
  min-width: 0;
  margin-bottom: 0;
}

/* Names the board that is on screen, for assistive tech only — see the comment at its call site. */
.top__status {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* The filter takes enough of the row that the title wraps; balanced, it breaks mid-phrase rather
   than dropping a single word onto the second line. */
.top__headText h2 {
  text-wrap: balance;
}

.popular__more {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .top,
  .popular {
    padding: 56px 0;
  }
}
